<b
  class="word-break item-link"
  role="button"
  (click)="onDisplayPopup(value)"
  [attr.data-test-id]="dataTestId + rowIndex"
>
  {{ entityName }}
</b>
